import Section from '@/uikit/components/Section/Section';
import styles from './PressArticleSection.module.scss';
import type { PressArticleSectionProps } from './types';

const PressArticleSection = ({ children }: PressArticleSectionProps) => {
  return <Section className={styles.base}>{children}</Section>;
};

export default PressArticleSection;
